import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

const FALLBACK = {
  thresholdCpu: 80,
  thresholdRam: 90,
  thresholdDisk: 85,
  telegramToken: null,
  telegramTokenSet: false,
  telegramChatId: "",
  telegramFormat: "plain",
  notifyOnCrit: true,
  notifyOnRecover: true,
  notifyOnOffline: true,
  cooldownEnabled: true,
  cooldownSeconds: 300,
  offlineThresholdMs: 30_000,
};

/**
 * Loads the hub's persistent app_settings row + exposes a `save(patch)` that
 * PUTs the partial update and refreshes the local copy. Returns the
 * `FALLBACK` shape while loading so consumers can render without nullchecks.
 */
export function useSettings() {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastSavedAt, setLastSavedAt] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .getSettings()
      .then((s) => {
        if (cancelled) return;
        setSettings({ ...FALLBACK, ...s });
        setLoading(false);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const save = useCallback(async (patch) => {
    const updated = await api.updateSettings(patch);
    setSettings({ ...FALLBACK, ...updated });
    setLastSavedAt(Date.now());
    return updated;
  }, []);

  return { settings, loading, error, save, lastSavedAt };
}
